<template>
  <div :class="modalTheme" style="max-height: 33vh; overflow-y: auto">
    <!-- <h6>xx modalTheme: {{ modalTheme }}</h6> -->

    <!-- usrSelectRowId |{{ usrSelectRowId }} -->
    <!-- <button @click="getSelectedData">Get</button> -->
    <!-- <div class="master-detail-caption">Incoming: {{ templateData.length }}</div> -->
    <!-- <h3 style="color:yellow;">Detail Template grid</h3> -->
    <div v-if="AreIdsShown" style="background: black; color: cyan">workListStore selectedContractMeasDetails {{ workListStore.selectedContractMeasDetails?.length }}</div>
    <!-- <div v-if="AreIdsShown" style="background:black;color:#35fa0d;">SENDING 2grid ...filterContractDetails {{ filterContractDetails.length }}</div> -->
    <div v-if="AreIdsShown" style="background: darkorange; color: darkblue">workListStore filteredContractMeasDetails {{ workListStore.filteredContractMeasDetails }}</div>

    <slot :recordsSelected="recordsSelected"></slot>

    <DxDataGrid
      class=""
      :ref="dataGridRefName"
      :data-source="workListStore.filteredContractMeasDetails"
      :repaint-changes-only="true"
      :row-alternation-enabled="false"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :auto-expand-all="false"
      :focused-row-enabled="false"
      key-expr="id"
      :two-way-binding-enabled="true"
      :show-borders="true"
      :columns="fieldsDetailsRecordsArray"
      noDataText="No Records  were found ........"
      @row-expanded="onRowExpanded"
      @row-collapsed="onRowCollapsed"
      @row-click="toggleRow1"
      @row-prepared="onRowPrepared"
      @selection-changed="selectionChanged"
      @exporting="onExporting"
      @cell-prepared="onCellPrepared"
      @toolbar-preparing="onToolbarPreparing"
    >
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="true" />
      <DxEditing :allow-updating="false" :allow-adding="false" :allow-deleting="false" mode="cell" />

      <DxExport :enabled="true" />

      <DxSearchPanel :visible="false" />
      <DxPaging :enabled="true" :pageSize="25" />
      <DxPager :visible="true" :display-mode="displayMode" :show-page-size-selector="true" :show-info="showInfo" :show-navigation-buttons="showNavButtons" />
      <DxSelection mode="single" />
      <!-- <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->
      <!-- <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->
      <DxScrolling :use-native="true" mode="standard" />
      <!-- <DxSelection  v-if="CanDelegate" select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->
      <!-- <dx-column type="buttons" caption="Status1" data-field="status">
          <dx-button name="save" css-class="my-class" />
          <dx-button name="edit" />
          <dx-button name="delete" />
           Declare and configure custom buttons here
           <div v-if="status === 'Not Addressed'"><h1>NOT</h1></div>
          <dx-button text="Set Status" :on-click="setStatus" icon="/content/images/CM_green.png"></dx-button>
          <dx-button text="Set Status" :on-click="setStatusR" icon="/content/images/CM_red.png"></dx-button>
          <dx-button text="Set Status" :on-click="setStatusY" icon="/content/images/CM_yellow.png"></dx-button>
        </dx-column>
			<img @click="changeStatus()" v-b-popover.hover.top="'Change Status'" src="/content/images/littleglight.png" />-->
      <!-- <dx-column data-field="id" caption="Id" /> -->
      <DxColumn v-if="AreIdsShown" data-field="id" caption="id" />

      <!-- <DxColumn data-field="lastName" caption="Last Name" cell-template="lastName" width="auto" />
			<DxColumn data-field="firstName" caption="First Name" cell-template="firstName" width="110" />
			<DxColumn data-field="middleName" caption="Middle" width="20" />
			<div slot="lastName" slot-scope="{ data }">
				<router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link>
			</div>
			<div slot="firstName" slot-scope="{ data }">
				<router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.firstName }}</router-link>
			</div> -->

      <DxColumn data-field="lastName" caption="Last Name" cell-template="lastName" />
      <template #lastName="{ data }">
        <!-- {{ data.text }} -->
        <!-- <router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link> -->
        <b-nav pills justified>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.lastName }}</b-nav-item>
        </b-nav>
      </template>

      <DxColumn data-field="firstName" caption="First Name" cell-template="firstName" />
      <template #firstName="{ data }">
        <!-- {{ data.text }} -->
        <!-- <router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link> -->
        <b-nav pills justified>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.firstName }}</b-nav-item>
        </b-nav>
      </template>
      <DxColumn data-field="middleName" caption="Middle" />

      <DxColumn data-field="dateOfBirth" caption="DOB" cell-template="formatDate-template" alignment="center" width="200" />
      <!-- <DxColumn data-field="dueDate" caption="Due Date" cell-template="formatDate-template" /> -->
      <DxColumn data-field="dueDate" caption="Due Date" alignment="center" width="120" />
      <DxColumn data-field="lastSeen" caption="Last Seen" cell-template="formatDate-template" alignment="center" />
      <DxColumn data-field="lastSeenBy" caption="Last Seen by" alignment="center" />
      <DxColumn data-field="nextAppointment" caption="Next Appointment" sort-order="desc" cell-template="formatDate-template" alignment="center" />
      <DxColumn data-field="providerName" caption="Provider Name" sort-order="desc" cell-template="one-template" />
      <!--  Master  MASTER   MASTER DETAIL      TASK COMMENTS -->
      <DxMasterDetail :enabled="false" template="measuresDetail" />
      <!-- & tmp   Template:  PATIENT  MEasures  COMMENT  FORM -->
      <template #measuresDetail="{ data: record }">
        <div style="background: transparent; padding: 0px; height: 100%; max-height: 330px; overflow-y: auto">
          <b-row style="background-color: transparent; padding: 0px">
            <b-col style="padding: 10px">
              <h4 v-if="AreIdsShown">xxx usrSelectRowId {{ usrSelectRowId }}</h4>
              <!-- <h2>this.Id ? personID = {{id}}</h2> -->
              <!-- <h3 v-if="AreIdsShown" style="color:red;">OVERHAUL RECORD : record</h3> -->
              <h6 style="background-color: darkblue; color: cyan" v-if="AreIdsShown">localRowId {{ localRowId }}</h6>

              <!-- <h3> PatientMeasuresCommentsForm</h3> -->

              <PatientMeasuresCommentsForm :rowId="usrSelectRowId" :measures-data="record" @post-comment="onPostComment" />
            </b-col>
            <!-- <b-col cols="4"></b-col> -->
            <!-- <b-col v-if="record.data.contractMeasureComments.length > 0" cols="4">
							<DxDataGrid :data-source="record.data.contractMeasureComments" :allow-column-resizing="true"
								:column-auto-width="true" :repaint-changes-only="true" :two-way-binding-enabled="true"
						:show-borders="true">-->
            <!-- <DxColumn width="20%" data-field="type" caption="Type" /> -->
            <!-- <DxColumn width="80%" data-field="description" caption="Description" /> -->
            <!-- </DxDataGrid>
						</b-col>-->
          </b-row>
          <!-- <h2>DxDataGRid data-source="task.data. YES" usrSelectRowId {{usrSelectRowId}} : Task = {{task.data.id}}</h2>
					<h2>detail Data taskComments : {{task.data.taskComments.length}}</h2>
					<h3 style="background-color:blackcolor:orange">THIS IS NEW GRID</h3>-->
          <!-- <DxDataGrid :data-source="task.data.taskComments" :column-auto-width="true" :repaint-changes-only="true" :two-way-binding-enabled="true" :show-borders="true"></DxDataGrid> -->
        </div>
      </template>

      <template #formatDate-template="{ data }">
        <span>{{ useFormatDate(data.text) }}</span>
      </template>

      <template #one-template="{ data }">
        <!-- <span>{{ formatDate(data.text) }}</span> -->
        <span>{{ data.text }}</span>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

import { getPatientMeasures, postMeasuresComment, getContractMeasureComments } from "@/api/discreteDataApi";

// & COMPOSIBLEs
import { useFormatDate } from "@/use/formatDate.js";

import PatientMeasuresCommentsForm from "@/modules/Patient/PatientMeasuresCommentsForm.vue";

import {
  DxDataGrid,
  DxColumn,
  DxButton,
  DxPager,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxLoadPanel,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxMasterDetail,
  DxSelection,
  DxScrolling,
  DxExport,
} from "devextreme-vue/data-grid";

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import { DxTooltip } from "devextreme-vue/tooltip";
import { functionsIn } from "lodash-es";

// & PROPS
const props = defineProps({
  templateData: {
    Type: Object,
    Default: () => {},
  },
  fields: {
    Type: Array,
    Default: () => {},
  },
  selectedFileName: {
    Type: String,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);

const localRowId = ref("");
const usrSelectRowId = ref("");

function onToolbarPreparing(e) {
// console.dir(e);
  var item = e.toolbarOptions.items.find((item) => item.name === "exportButton");
// console.log("item");
  // console.log(item.style.width='150px')

// console.log("       item opts");
  //
  // // console.log(item)

  // item.options.icon: 'export',
  item.showText = "always";
}

function onRowPrepared(e) {
  // //// console.clear()()
// console.log("				detail tempolartereme RECORD SELECTOR					onRowPrepared						______________________rowElement..e......");

// console.log("_________________________________");
  //// console.log(' start  E: ')

  //// console.dir(e)
  //// console.log('														______________________rowElement........')
  const rowElement = e.rowElement;
  // //// console.dir(rowElement)

  rowElement.style.cursor = "pointer";
  const record = e.data;

  //// console.log('record........')

  //// console.dir(record)
  //// console.log('RecordID: ' + record.id)

  if (!record) return; // this is probably a header or footer row and thus doesn't have the data property

  if (record.status === "Y") {
    if (modalTheme.value === "generic-light-modal") {
      rowElement.style.backgroundColor = "#dcf1de";
      rowElement.style.color = "#123486";
    } else if (modalTheme.value === "generic-dark-modal") {
      rowElement.style.backgroundColor = "#1e3120";
      rowElement.style.color = "#DCF1DE";
    }
    // rowElement.style.fontWeight = 900; // Uncomment if you want bold
  } else if (record.status === "N") {
    if (modalTheme.value === "generic-light-modal") {
      rowElement.style.backgroundColor = "#e7caca";
      rowElement.style.color = "#123486";
    } else if (modalTheme.value === "generic-dark-modal") {
      rowElement.style.backgroundColor = "#6a2323";
      rowElement.style.color = "#DCF1DE";
    }
    rowElement.style.fontWeight = 900;
  }

  // // Measure status coloring with modal theme
  // if (record.measureStatus === "1") {
  //   if (modalTheme.value === "generic-light-modal") {
  //     rowElement.style.backgroundColor = "#e7caca";
  //     rowElement.style.color = "#123486";
  //   } else if (modalTheme.value === "generic-dark-modal") {
  //     rowElement.style.backgroundColor = "#6a2323";
  //     rowElement.style.color = "#DCF1DE";
  //   }
  // } else if (record.measureStatus === "2") {
  //   if (modalTheme.value === "generic-light-modal") {
  //     rowElement.style.backgroundColor = "#fbe7b7";
  //     rowElement.style.color = "#123486";
  //   } else if (modalTheme.value === "generic-dark-modal") {
  //     rowElement.style.backgroundColor = "#66512c";
  //     rowElement.style.color = "#DCF1DE";
  //   }
  // } else if (record.measureStatus === "3") {
  //   if (modalTheme.value === "generic-light-modal") {
  //     rowElement.style.backgroundColor = "#b6fce3";
  //     rowElement.style.color = "#123486";
  //   } else if (modalTheme.value === "generic-dark-modal") {
  //     rowElement.style.backgroundColor = "#1e3120";
  //     rowElement.style.color = "#DCF1DE";
  //   }
  // }

  e.columns.forEach((col) => {
    if (col.index >= 0) {
      // //// console.log(' index > 0')
      //// console.log(col)
      //// console.log(col.name)
      if (col.index === 0) {
        //// console.log(col.name)
        //// console.log(e.rowElement.cells[0].style)
        // e.rowElement.cells[1].bgColor = 'red'
      }
      //// console.log(col.index)
      if (col.name === "lastName") {
        // e.rowElement.cells[0].bgColor = 'red'
        // e.rowElement.cells[0].style.color = 'yellow'
      }

      if (e.columns[1].name === "priority") {
        // e.rowElement.cells[1].minWidth = 5
        // //// console.clear()()
        // //// console.log(col)
        //// console.log(' index > algn left')
        e.columns[1].alignment = "left";
        e.rowElement.cells[1].bgColor = "red";
        // e.rowElement.cells[1].minWidth =10
        //// console.log(e.rowElement.cells[1])
      }
      if (e.rowElement.dataField == "priority") {
        //// console.log(' dF = prior ')
        // e.rowElement.cells[1].alignment = 'center'
        // e.rowElement.cells[1].bgColor = 'red'
        // // e.rowElement.cells[1].width = '20px'
        // e.rowElement.cells[1].style.color = 'green'
        // e.rowElement.cells[1].style.padding = '0%'
        // //e.rowElement.cells[1].style.height = '3px'
        // e.rowElement.cells[1].minWidth = 20
        // e.rowElement.cells[1].style.width = '12px'
        //  e.rowElement[0].style.height = '10px !important'
        //  e.rowElement.css({ height: 6})
      }
      // if (this.FromLabs) {
      // 	//// console.log('  FROM LABs ')
      // 	if (col.name === 'description') {
      // 		// e.rowElement.cells[2].bgColor = 'transparent'
      // 		// e.rowElement.cells[2].style.color = 'red'

      // 		col.width = 220
      // 	} else {
      // 		// e.rowElement.cells[3].bgColor = 'darkred'
      // 		// e.rowElement.cells[3].style.color = 'pink'
      // 		// //// console.log(e.rowElement.cells[3])
      // 		col.width = 30
      // 		//col.alignment='center'
      // 		if (col.name === 'testName') {
      // 			// //// console.log('_________________________________')
      // 			// //// console.log('COLUMN')

      // 			// //// console.log('NAME: ' + col.name)
      // 			// //// console.log(' testName > E: rowElement')
      // 			// //// console.dir(e.rowElement)
      // 			// //// console.log('_________________________________')

      // 			// e.rowElement.cells[1].bgColor = 'transparent'
      // 			// e.rowElement.cells[1].style.color = 'blue'

      // 			if (col.minWidth === 80) {
      // 				// //// console.log('FOUND 80')
      // 				// e.rowElement.cells[1].bgColor = 'red'
      // 				// e.rowElement.cells[1].style.color = 'white'
      // 				// e.rowElement.cells[1].style.width = '20'
      // 				col.width = 250
      // 				// e.rowElement.cells[2].width = 450
      // 				//col.minWidth = 30
      // 				//e.rowElement.cells[1].width = '20'
      // 			}
      // 		}
      // 	}
      // }
      // 								{
      // 									//// console.clear()()

      // 									//// console.log(col)

      // 									col.minWidth = '10'

      // 									//// console.log('E: rowElement')

      // 									//// console.dir(e.rowElement)

      // //									e.rowElement.bgColor = 'green'
      // 									//e.rowElement.style.backgroundColor = 'blue'
      // 									 e.rowElement.style.color = 'black'
      // 									 e.rowElement.width = '50'
      // 									 e.rowElement.align = 'left'

      // 									// & ADD CLASS to ROW
      // 									// e.rowElement.classList.add('testClass')
      // 								}
      // 								else
      // 								{
      // 									e.rowElement.bgColor = 'darkorange'
      // 									e.rowElement.style.color = 'yellow'
      // 									 e.rowElement.style.align = 'center'
      // 									 e.rowElement.width = '30'
      // 									 e.rowElement.align = 'center'
      // 								}
      // //// console.log('end...')
    }
  });

  // 	// //// console.log('col.name : ', col.name)

  //   if (col.name === 'Test Name') {
  // 		//// console.log(' found   Test Name')
  // 		// rowElement.style.backgroundColor = 'red'
  // 		// rowElement.style.color = 'yellow'
  //   }
  //   // this.filterOptions.push({ text: item.label, value: item.value })
  // })
}

function onRowExpanded(e) {
  // //console.clear()()
// console.log(" on ROW EXPPPPPPPPPPPPPPPPP");

  usrSelectRowId.value = e.key;
  // console.log(' 	GET usrSelectRowId on EXPANd:  ', usrSelectRowId.value)
  // console.log(' ...			... ')
  // console.log(e.row.data)
  onCellClick(e);
}

function onRowCollapsed(e) {
  // // //console.clear()()
  // console.log(' 										...	 on Row COLLAPSED		... ')
  usrSelectRowId.value = e.key;
  // // console.log(' ...	MY ROW KEY : 		... ', usrSelectRowId.value)
}

function toggleRow1(e) {
  // if (this.dataGridInstance.isRowExpanded)
  // //console.clear()()
  e.isRowExpanded = !e.isRowExpanded;

  //TODO REFACTOR A NEW TOGGLE
  // if (e.isExpanded) {
  // 	// console.log(' ROW is EXP')
  // 	// console.log('collllllll')
  // 	this.dataGridInstance.collapseRow(e.key)
  // } else {
  // 	// console.log('NO ROW EX')
  // 	this.dataGridInstance.expandRow(e.key)
  // }
}
function onCellClick(e) {
  // //console.clear()()

// console.log("			Dash MEASURES >  Record Selector													onCellClick (e) ");
  // // console.log(' E   get isSelected? ?c xC? c? ')

// console.log("									 e.rowType === data");
// console.dir(e);

  if (e.rowType === "data") {
    const currentSelectedRow = e.row.data;
// console.log("ONCELL CLICK :  currentSelectedRow");
// console.dir(currentSelectedRow);

    if (e.columnIndex === 4) {
      e.cellElement.style.fontWeight = "bolder";
      e.cellElement.style.color = "blue";
      e.cellElement.style.backgroundColor = "red";
    }

    // // console.log(
    // 'REFerence props coming :	dataIndex:0	isEditing:false	isExpanded:false	isSelected:true	key:"12|4248|1"	rowIndex:	0				rowType:"data"				'
    // )

    // var somethingSelected = e.row.isSelected
    // // console.log('somethingSelected bool: ' + somethingSelected)
    // // console.log(' somethingSelected   end something')

    // if (somethingSelected) {
    // // console.log(
    // '		TRUE :      somethingSelected bool: ' + somethingSelected
    // )
    // // console.log(' SET the CURRENT Task ')
    // this.currentTask = e.row.data
    // // console.log('this.currentTask')
    // // console.dir(this.currentTask)
    // // console.log(						'			cell CLICK      EMIITTing  current-task  : ',						this.currentTask.id					)

    // this.$emit('current-task', this.currentTask)
    // } else if (!somethingSelected) {
    // // console.log('			q :      somethingSelected bool: ' + somethingSelected)
    // // console.log(this.getAllTaskRecords.length)

    // if (this.getAllTaskRecords.length === 1) {
    // // console.log(' CLear by ID')
    //	this.$store.commit('clearPatientTaskRecordsBySourceId',CampaignSourceIds.Vitals,)
    // }
    // }
    // && (this.getAllTaskRecords.length === 0))
    // {
    // 	// // console.log('			q :      somethingSelected bool: ' + somethingSelected)
    // 	// // console.log(' CLEAr the TaskRecords for the CORRes SourceID : ???')
    // 	//this.$store.commit('clearPatientTaskRecords')
    // 	this.currentTask = e.row.data
    // 	// // console.log('this.currentTask')
    // 	// // console.dir(this.currentTask)

    // 	this.$store.commit('clearPatientTaskRecordsBySourceId',CampaignSourceIds.Vitals,)

    // }
  }

  // // // // console.log('				column.datafield  CHECK for    status  ')
  // if (e.column.dataField === 'status') {
  // 	// // // console.log('														FOUND:  ', e.column.dataField)
  // 	// // // console.log(
  // 		'You CLICK the ' + e.column.name + ' column  : value = ' + e.value
  // 	)

  // 	// // // console.log('  CHECK  BIND : 	this.currentTask = e.row.data  ')
  // 	// // console.dir(e.row.data)

  // 	this.currentTask = e.row.data

  // 	// // // console.log('										CURRENT TASK:  	', this.currentTask)

  // 	this.openStatusModel(e)
  // } else if (e.column.dataField === 'originalOwner') {
  // 	this.modalOrgOwnerName = e.value
  // 	this.showModal1 = !this.showModal
  // } else {
  // 	// // // console.log('														FOUND:  ', e.column.dataField)
  // 	// // // console.log('																	CELL >>>  THIS = e.value', e.value)
  // }
}

function onCellPrepared(e) {
  // console.log(' DETAIIL TEMPLATE   onCellPrepared ')
  // console.log("E")
  // console.log(e)
  // console.log(e.column.dataField)
  // console.log()
  // console.log(' E.value')
  // console.log(e.value)

  // console.log(' handleNULLDateDASH TARGET test')
  // 	e.cellElement.style.color = 'yellow'
  // 	e.cellElement.style.backgroundColor = 'darkred'

  if (e.column.dataField === "lastSeen" || e.column.dataField === "nextAppointment") {
// console.log(" dataField : ");
// console.dir(e.column.dataField);
// console.log("THIS format of DATE is done on the USE.formatDate function on the HTML GRID ");
    // 	e.cellElement.style.color = 'green'
    // e.cellElement.style.backgroundColor = 'yellow'
  }
}

function selectionChanged(e) {
  // //// console.clear()()
  //// console.log('			MyMeasures Details Comments > selectionChange()')
  //// console.dir(e)
  //// console.log('________________________________')

  e.component.collapseAll(-1);
  e.component.expandRow(e.currentSelectedRowKeys[0]);
}
function onExporting(e) {
// console.clear();
  // console.log(e)
// console.log(e.fileName);
  // * NEW FILENAME BINDING
  e.fileName = workListStore.measuresFilters.selectedContractMeasFileName;

// console.log(e.fileName);

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      options.excelCell.font = { name: "Arial", size: 12 };
      options.excelCell.alignment = { horizontal: "left" };
    },
  }).then(function () {
// console.log(" 												  ... saveAS");

    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), e.fileName + ".xlsx");
    });
  });
}

async function onPostComment(comment) {
  //// console.clear()()
// console.log("ON POST COMMENT: NEW ******************************************************************************************** ");
  // //// console.log('ON POST COMMENT: NEW ')
  // //// console.log('ON POST COMMENT: NEW ')
  // console.log('ON POST COMMENT: NEW ************************************************************************* ')

// console.dir(comment);

  // // console.dir(comment.patientId)
  // // console.dir(comment.parentId)

  // // console.log(' comment.patientId			')
  // // console.log(comment.patientId)
// console.log("																						 usrSelectRowId.value		");
// console.log(usrSelectRowId.value);

  //
  // console.log(' localRowId		')
  // console.log(localRowId.value)
  //
// console.log(" comment.text			");
// console.log(comment.text);
// console.log(" comment.patientId			");
// console.log(comment.patientId);
  // //// console.log('ON POST 		COMMENT: check comment  ', comment)
  // console.log('		>>>>>>>>>>>>>		ON POST COMMENT : ', comment.text)
  // console.log('		SENDING:  localRowId: ' + localRowId.value + ' TXT: ' + comment.text + ' pId: ' + comment.patientId)
  // //// console.log(' 	this.patientId: ' + this.patientId)
  //// console.log('		SENDING:  	localRowId.value: ' + localRowId.value)

  //? postTaskComment    ID changed    was  localRowId.value.id
  const response = await postMeasuresComment(usrSelectRowId.value, usrSelectRowId.value, comment.text);

  // console.log('		********		RET:Payload >>>')
  // console.dir(response.payload)
  // console.log(' 		onPostComment  	STORE  ARRAY of  ?  PATIENTS TASKs setCurrentPatientMeasuresComments []')

  // todo GET PATIENT TASKS
  if (response.ok) {
    // // console.log(' vthis.patientId		')
    // // console.log(this.patientId)

// console.log("2  getContractMeasureComments  localRowId		");
    // console.log(localRowId.value)

    await getPatientMeasuresCall();

    // // console.log('   TODO   CHECK THIS  response		')
    // // console.log('2  getContractMeasureComments  localRowId		')
    // console.log('2  getContractMeasureComments  localRowId		')

    const responseX = await getContractMeasureComments(usrSelectRowId.value);
    // console.log('  responseX    ...................  STORE setCurrentPatientMeasuresComments ')
    // console.log('  responseX    ...................  STORE setCurrentPatientMeasuresComments ')
    // console.log('  check STORE holder ???????????????? ')
    // console.log(responseX)
    // this.$store.commit('setCurrentPatientMeasuresComments',responseX)
    patientStore.setCurrentPatientMeasuresComments(responseX);
    // 	// this.currentContractMeasure = responseX
    // // console.log(this.currentContractMeasure)

    // this.$store.commit('setCurrentSelectedPatientMeasures', this.currentContractMeasure)
    // // TODO TASK COMMENTS - CHECK FORM DeCOMPILE
    // // console.log('RUN  commit setCurrentPatientMeasuresComments')
    // this.$store.commit('setCurrentPatientMeasuresComments', responseX)
  }

  if (!response.ok) {
    toastrError("There was a problem submitting the COMMENT.  Please try again or contact technical support.");
    return;
  }
  toastrSuccess("Successfully posted new Measures Comment");

  // if (response.ok) {
  // 	this.regetTasks()
  // }
  // this.showModal = false
}

async function getPatientMeasuresCall() {
  // if (this.allMyMeasures.length <= 0) {
  // //// console.clear()()
  // console.log(' ......................... 	getPatientMeasuresCall  ')
  // console.log(	'   GOING TO Worklist STOREs API call   await this.getAllMyMeasuresStoreToAPI()'			)
  const response = await workListStore.getAllMyMeasuresStoreToAPI();
// console.log(" ......................... 	response  ");
// console.log(response);
// console.log(" ......................... 	response  ");

  // if (response.ok) {
  // 	// console.log('			......................OK')
  // 	// console.log('MEASURES filling >' + '  PatientId = ' + this.patientId)

  // 	// STORE  STORE -->
  // 	// console.log('	# >>> SETTING  ......this.measures = response.payload.records...........')

  // 	this.measures = this.allMyMeasures

  // 	// Get provider list
  // 	this.providerNameList = []

  // 	this.measures.forEach((r) =>
  // 	{
  // 		// // console.log(' 0 ')
  // 		// // console.log(' 0 r.providerName < '+ r.providerName)
  // 		this.providerNameList.push(r.providerName)
  // 	})
  // 	// this.measures = allMyMeasures
  // 	// console.log('provider lIst ')
  // 	// console.log(this.providerNameList)

  // 	// console.log('NEW SET')

  // 	this.providerNameList = [...new Set(this.getContractMeasuresFilters.providerNamesList)]

  // 	// console.log([...new Set(this.providerNameList)])
  // 	// console.log(this.providerNameList)

  // 	// this.providerNameList.forEach((name) => {
  // 	// 	// console.log(' name : ' + name)
  // 	// 	this.searchTerms.push(name)
  // 	// 	// console.log(this.searchTerms)
  // 	// })

  // 	// console.log(this.getContractMeasuresFilters.providerName)

  // 	// this.measures = []
  // 	// // console.dir(this.allMyMeasures)
  // 	// console.dir(this.measures)

  // 	return this.measures
  // }

  // }
  // else {dark
  // 	return this.measures = this.allMyMeasures
  // }
}

onMounted(() => {
// console.log("onMounted() :      DetailTemplate >>>>");

  // console.clear()
// console.log("detail template comp created");
  // // console.log('INCOMING ')
// console.log("props.templateData");
// console.log(props.templateData);
  // workListStore.selectedContractMeasDetails = props.templateData
  workListStore.setCurrentContractMeasuresDetails(props.templateData);

// console.log("props.selectedFileName");
// console.log(props.selectedFileName);
  workListStore.setCurrentContractMeasuresDetailFileName(props.selectedFileName);
});
</script>

<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}
</style>
